export default __webpack_public_path__ + "locales/el-GR/HotkeysPanel.json?hash=03bf7d62868765b9ac8510e558fc335b";